module.exports = __webpack_public_path__ + "img/primary-visa-card.e1626c7b.svg";